import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createSlots as _createSlots, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { id: "pane-container" }
const _hoisted_2 = { class: "pane" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-start" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-center my-3" }
const _hoisted_6 = {
  key: 0,
  class: "text-center my-1"
}
const _hoisted_7 = {
  key: 1,
  class: "text-center"
}
const _hoisted_8 = { class: "text-danger my-1" }
const _hoisted_9 = {
  key: 0,
  class: "multiselect__single"
}
const _hoisted_10 = {
  key: 1,
  class: "multiselect__single"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "option__desc" }
const _hoisted_13 = { class: "option__title" }
const _hoisted_14 = { class: "option__small" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner")
  const _component_b_button = _resolveComponent("b-button")
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")
  const _component_b_dropdown = _resolveComponent("b-dropdown")
  const _component_b_button_group = _resolveComponent("b-button-group")
  const _component_b_form_input = _resolveComponent("b-form-input")
  const _component_v_multiselect = _resolveComponent("v-multiselect")
  const _component_b_table = _resolveComponent("b-table")
  const _component_DepartmentCostPane = _resolveComponent("DepartmentCostPane")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, "Kostenübersicht " + _toDisplayString($data.year), 1 /* TEXT */),
        _createVNode(_component_b_button_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_button, {
              id: "btn-export-employees",
              title: 'Alle bestellten Artikel aus ' + $data.year + ' herunterladen',
              class: "text-nowrap",
              style: {"width":"52px"},
              onClick: _cache[0] || (_cache[0] = $event => ($options.downloadArticles()))
            }, {
              default: _withCtx(() => [
                (!$data.isExporting)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("i", { class: "fas fa-download" }, null, -1 /* CACHED */),
                      _createElementVNode("i", { class: "fas fa-file-excel" }, null, -1 /* CACHED */)
                    ]))]))
                  : (_openBlock(), _createBlock(_component_b_spinner, {
                      key: 1,
                      small: ""
                    }))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title"]),
            _createVNode(_component_b_button, {
              title: "Alle Filter zurücksetzen",
              class: "text-nowrap",
              onClick: _cache[1] || (_cache[1] = $event => ($options.resetFilters()))
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */),
                _createElementVNode("i", { class: "fas fa-filter" }, null, -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_b_dropdown, {
              class: "btn-group",
              "no-flip": "",
              text: "Jahr"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.invoiceYears, (value) => {
                    return (_openBlock(), _createBlock(_component_b_dropdown_item, {
                      key: value,
                      onClick: $event => ($data.year = value)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(value), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _createVNode(_component_b_table, {
        ref: "table",
        busy: $data.isBusy,
        "onUpdate:busy": _cache[6] || (_cache[6] = $event => (($data.isBusy) = $event)),
        fields: $data.fields,
        items: $options.filteredItems,
        class: "bootstrap-vue-table-borders",
        "head-variant": "dark",
        "show-empty": "",
        selectable: "",
        "select-mode": "single",
        "no-select-on-click": "",
        "primary-key": "id",
        "sticky-header": "100%",
        "sort-by": [{key: 'name', order: 'asc'}]
      }, {
        "table-busy": _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_b_spinner, {
              small: "",
              type: "grow",
              variant: "secondary"
            }),
            _createVNode(_component_b_spinner, {
              style: {"animation-delay":"0.1s"},
              small: "",
              type: "grow",
              variant: "secondary"
            }),
            _createVNode(_component_b_spinner, {
              style: {"animation-delay":"0.2s"},
              small: "",
              type: "grow",
              variant: "secondary"
            })
          ])
        ]),
        empty: _withCtx(() => [
          (!$data.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Keine passenden Ergebnisse gefunden. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, " Ein Fehler ist aufgetreten (" + _toDisplayString($data.error.message) + "). ", 1 /* TEXT */),
                _createVNode(_component_b_button, {
                  onClick: _cache[2] || (_cache[2] = $event => ($options.fetchData()))
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("i", { class: "fa-solid fa-rotate-right me-1" }, null, -1 /* CACHED */),
                    _createTextVNode("Erneut versuchen. ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]))
        ]),
        "head()": _withCtx(({field}) => [
          _createElementVNode("div", null, _toDisplayString(field.label), 1 /* TEXT */),
          _createElementVNode("div", null, [
            (field.filter && (field.filter.type === 'string-contains'
                || field.filter.type === 'decimal-number-contains'))
              ? (_openBlock(), _createBlock(_component_b_form_input, {
                  key: 0,
                  modelValue: field.filter.value,
                  "onUpdate:modelValue": $event => ((field.filter.value) = $event),
                  type: "text",
                  size: "sm",
                  placeholder: "Suchen...",
                  debounce: "200",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
              : _createCommentVNode("v-if", true),
            (field.filter && field.filter.type === 'string-equals')
              ? (_openBlock(), _createBlock(_component_b_form_input, {
                  key: 1,
                  modelValue: field.filter.value,
                  "onUpdate:modelValue": $event => ((field.filter.value) = $event),
                  type: "text",
                  size: "sm",
                  placeholder: "Gleich...",
                  debounce: "200",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
              : _createCommentVNode("v-if", true),
            (field.filter && field.filter.type === 'multiselect')
              ? (_openBlock(), _createBlock(_component_v_multiselect, {
                  key: 2,
                  modelValue: field.filter.value,
                  "onUpdate:modelValue": $event => ((field.filter.value) = $event),
                  options: field.filter.options || [],
                  multiple: true,
                  "track-by": "id",
                  label: "name",
                  "close-on-select": false,
                  "show-pointer": false,
                  "selected-label": "✓",
                  "open-direction": "bottom",
                  placeholder: "Filtern...",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                }, _createSlots({
                  selection: _withCtx(({ values, isOpen }) => [
                    (values.length > 1 && !isOpen)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(values.length) + " Werte ", 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (values.length === 1 && !isOpen)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(values[0].short || values[0].name), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  beforeList: _withCtx(() => [
                    _createElementVNode("li", {
                      class: "multiselect__option",
                      onClick: $event => (field.filter.value = [])
                    }, [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */),
                      _createTextVNode(" Filter löschen ", -1 /* CACHED */)
                    ]))], 8 /* PROPS */, _hoisted_11),
                    _cache[11] || (_cache[11] = _createElementVNode("li", { class: "dropdown-divider" }, null, -1 /* CACHED */))
                  ]),
                  noResult: _withCtx(() => [
                    _cache[12] || (_cache[12] = _createTextVNode(" Keine Inhalte gefunden. ", -1 /* CACHED */))
                  ]),
                  _: 2 /* DYNAMIC */
                }, [
                  (field.key === 'status')
                    ? {
                        name: "option",
                        fn: _withCtx((props) => [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, _toDisplayString(props.option.name), 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_14, [
                              _createElementVNode("i", {
                                class: _normalizeClass(props.option.icon)
                              }, null, 2 /* CLASS */)
                            ])
                          ])
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "options"]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        "cell(details)": _withCtx(({item}) => [
          _createVNode(_component_b_button, {
            size: "sm",
            onClick: $event => ($options.showDetails(item))
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createTextVNode(" ↳ ", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"])
        ]),
        "cell(balance)": _withCtx(({value, unformatted}) => [
          _createElementVNode("div", {
            style: _normalizeStyle({color: unformatted < 0 ? 'red' : null})
          }, _toDisplayString(value), 5 /* TEXT, STYLE */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["busy", "fields", "items"])
    ]),
    _createVNode(_component_DepartmentCostPane, {
      "details-url": $props.detailsUrl,
      department: $data.currentDepartmentId,
      year: $data.year
    }, null, 8 /* PROPS */, ["details-url", "department", "year"])
  ]))
}